import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';

export enum FlexDirection {
  row = 'Row',
  col = 'Col',
  /** used if we manage direction in elsewhere eg dynamic css classes */
  default = 'na',
}

export type FlexBoxContainer = JSX.Element | null;

export type FlexBoxProps = {
  children: Array<FlexBoxContainer | undefined> | FlexBoxContainer;
  dir?: FlexDirection;
  classes?: (n: number) => string;
  parentClasses?: string;
  dataModule: string;
  tag?: IModuleConfig['tag'];
};

/**
 * Places all children in a flexbox to align
 * IMPORTANT!! Make sure all elements have a key prop as
 */
export function FlexBlocks({
  children: _children,
  dir = FlexDirection.row,
  classes = () => '',
  parentClasses,
  dataModule,
  tag,
}: FlexBoxProps) {
  const flexType = 'u-flex';
  const children = Array.isArray(_children) ? _children : [_children];

  /**
   * only use classes on children i.e. not the first element
   * we iterate through possible undefined element so that the indexes correspons to passed in elements
   */
  const blocks = children
    .map((el, i) => {
      if (el) {
        if (!el.key) {
          messageLog.error(`Element ${dataModule} Does Not Have A Key`);
        }
        return (
          <div key={el.key} className={`flexblocks u-flexGrow-1 ${classes(i)}`}>
            {el}
          </div>
        );
      }
      return undefined;
    })
    .filter(isNotNullOrUndefined);
  if (blocks.length) {
    const dataModuleName = tag ? `${dataModule}-${tag}` : dataModule;
    return (
      <div data-module={dataModuleName} className={`flexblocks-container ${flexType} u-flex${dir} ${parentClasses}`}>
        {blocks}
      </div>
    );
  }
  return null;
}
